import store from '@/common/stores/store'

export const isOpportunityCenterEnabled = (): boolean => {
  return store.getters.user.is_staff
}
